/**
 * Constants for LinkNamesPanel form
 */
export const FORM_ID = 'link-names-form'

export const SELECTION_PREFIXES = {
  RECORD: 'linkStatesInRecord',
  IMAGE: 'linkStatesInImage',
  OTHER_ARKS: 'linkStatesInOtherArks',
}

/**
 * Get the default values for the checkboxes. The values are grouped in linkStatesInRecord, linkStatesInImage, and linkStatesInOtherArks groups.
 * @param {Array} personIdsSharingElement - Array of person ids sharing the element
 * @param {Array} personsInThisRecord - Persons in the current record
 * @param {Array} personsInThisImage - Persons in the current image
 * @param {Object} allTheArksExceptCurrent - person data for other arks section. Expects the ark entries to have a selected group.
 * @returns {{linkStatesInRecord: Object, linkStatesInImage: Object, linkStatesInOtherArks: Object}}
 */
export const getGroupedPersonsSelectionDefaults = ({
  personIdsSharingElement,
  personsInThisRecord,
  personsInThisImage,
  allTheArksExceptCurrent,
}) => {
  const defaultValues = {
    [SELECTION_PREFIXES.RECORD]: {},
    [SELECTION_PREFIXES.IMAGE]: {},
    [SELECTION_PREFIXES.OTHER_ARKS]: {},
  }

  const recordIdSet = new Set(personsInThisRecord.map((p) => p.id))
  const sharingElementIdSet = new Set(personIdsSharingElement)

  // Single pass: initialize all persons in record and image
  personsInThisRecord.forEach((person) => {
    const isSharing = sharingElementIdSet.has(person.id)
    defaultValues[SELECTION_PREFIXES.RECORD][person.id] = isSharing
  })

  personsInThisImage.forEach((person) => {
    const isSharing = sharingElementIdSet.has(person.id)
    defaultValues[SELECTION_PREFIXES.IMAGE][person.id] = isSharing
  })

  // Handle other arks
  Object.values(allTheArksExceptCurrent).forEach((obj) => {
    obj.selected.forEach((person) => {
      if (recordIdSet.has(person.id)) {
        defaultValues[SELECTION_PREFIXES.RECORD][person.id] = true
      }
      defaultValues[SELECTION_PREFIXES.OTHER_ARKS][person.id] = true
    })
  })

  return defaultValues
}
